import IntelligentQuestioning from './src/main';

/* istanbul ignore next */
IntelligentQuestioning.install = function(Vue) {
  Vue.component(IntelligentQuestioning.name, IntelligentQuestioning);
};

export default IntelligentQuestioning;
